var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMassageIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3513",
    "data-name": "Rectangle 3513",
    width: 64,
    height: 64,
    transform: "translate(-0.205 -0.013)",
    fill: "#fff"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_39",
    "data-name": "Group 39",
    transform: "translate(0.205 0.013)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_38",
    "data-name": "Group 38",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_458",
    "data-name": "Path 458",
    d: "M55.3,5.821a2.912,2.912,0,0,1,2.91,2.91V40.746a2.916,2.916,0,0,1-2.91,2.91H30.151L17.463,52.718V43.657H8.731a2.914,2.914,0,0,1-2.91-2.91V8.731a2.912,2.912,0,0,1,2.91-2.91ZM55.3,0H8.731A8.73,8.73,0,0,0,0,8.731V40.746a8.73,8.73,0,0,0,8.731,8.731h2.91V64.03L32.015,49.478H55.3a8.73,8.73,0,0,0,8.731-8.731V8.731A8.73,8.73,0,0,0,55.3,0",
    fill: "#fff"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMassageIcon);
export default __webpack_public_path__ + "static/media/massage-icon.c4c9dd876677deb9380f9daec5a4b992.svg";
export { ForwardRef as ReactComponent };